import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const AnnouncementContext = createContext();

export class AnnouncementProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnnouncement: null,
    };
  }

  selectAnnouncement = (announcement) => {
    this.setState({ selectedAnnouncement: announcement });
  };

  getContextValue = () => {
    return {
      ...this.state,
      selectAnnouncement: this.selectAnnouncement,
    };
  };

  render() {
    const { children } = this.props;

    return (
      <AnnouncementContext.Provider value={this.getContextValue()}>
        {children}
      </AnnouncementContext.Provider>
    );
  }
}

AnnouncementProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
